import React from 'react';
import { TBoxProps } from '../Box/Box';
import { Box } from '../Box/index';

type TNoOpLinkProps = {
  as?: TBoxProps['as'];
  className?: string;
  children?: TBoxProps['children'];
};

const NoOpLink = ({ as = 'em', ...rest }: TNoOpLinkProps) => <Box {...rest} as={as} name="Link" modifiers="noop" />;

export default NoOpLink;
